export default __webpack_public_path__ + "static/media/011-currency exchange.c6f77662.svg";